import type { ChatMessageDto } from '@/lib/api/sessions.client';
import type { IMessage } from '@/lib/types/chat';

type MessageParts = Pick<IMessage, 'contentBlocks' | 'compactedAt' | 'awaitingUser'>;

/**
 * What a stored answer is made of beyond its flat text: its blocks (tool calls
 * and their results, the text between them, Story 22.2), the places in them
 * where its history was summarised (KAN-1706), and the call among them that
 * waits for the user's answer (KAN-1874). The backend serializes the blocks as
 * `contentBlocks`; the snake_case twin is tolerated for in-flight DTOs.
 */
export const messagePartsOf = (m: ChatMessageDto): MessageParts => ({
  contentBlocks: (m.contentBlocks ?? m.content_blocks ?? undefined) as IMessage['contentBlocks'],
  compactedAt: m.compactedAt ?? [],
  awaitingUser: m.awaitingUser ?? null,
});
